module.exports = __webpack_public_path__ + "static/media/tabela-de-emolumentos.c0b0d6bf.pdf";